import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';

setAutoFreeze(false); // 禁止凍結

const localContact = JSON.parse(sessionStorage.getItem('custom-itinerary-contact'));

const initialState = {
  name: localContact?.name ?? '',
  gender: localContact?.gender ?? '',
  phone: localContact?.phone ?? '',
  email: localContact?.email ?? '',
};

export const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    contactUpdate: (state, action) => {
      sessionStorage.setItem('custom-itinerary-contact', JSON.stringify(action.payload));
      return action.payload
    },
  },
});

export const contactSelect = (state) => state.contact;
export const { contactUpdate } = contactSlice.actions;
export default contactSlice.reducer;
